import revive_payload_client_4sVQNw7RlN from "E:/TyApp/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "E:/TyApp/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "E:/TyApp/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "E:/TyApp/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "E:/TyApp/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "E:/TyApp/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "E:/TyApp/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "E:/TyApp/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "E:/TyApp/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "E:/TyApp/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import switch_locale_path_ssr_5csfIgkrBP from "E:/TyApp/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import i18n_sq1MuCrqbC from "E:/TyApp/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import plugin_client_OVoKJro5pc from "E:/TyApp/node_modules/@nuxtjs/color-mode/dist/runtime/plugin.client.js";
import element_plus_teleports_plugin_h4Dmekbj62 from "E:/TyApp/.nuxt/element-plus-teleports.plugin.mjs";
import element_plus_injection_plugin_1RNPi6ogby from "E:/TyApp/.nuxt/element-plus-injection.plugin.mjs";
import ssr_plugin_B4ptqVdIfe from "E:/TyApp/node_modules/@vueuse/nuxt/ssr-plugin.mjs";
import popper_client_m66wI84cVP from "E:/TyApp/plugins/popper.client.ts";
import svgicon_client_9ZXHQx4ITY from "E:/TyApp/plugins/svgicon.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  switch_locale_path_ssr_5csfIgkrBP,
  i18n_sq1MuCrqbC,
  plugin_client_OVoKJro5pc,
  element_plus_teleports_plugin_h4Dmekbj62,
  element_plus_injection_plugin_1RNPi6ogby,
  ssr_plugin_B4ptqVdIfe,
  popper_client_m66wI84cVP,
  svgicon_client_9ZXHQx4ITY
]